export default __webpack_public_path__ + "static/media/shop-local.b8626e2f.jpg";